import styled from 'styled-components';

import type { variants } from './types';

type VariantType = (typeof variants)[number];

const backgroundColors: { [key in VariantType]: string } = {
  grey: 'var(--c-nd-100)',
  red: 'rgba(var(--c-rgb-red-400), 0.25)',
};

const borderColor: { [key in VariantType]: string } = {
  grey: 'var(--c-nd-600)',
  red: 'var(--c-red-400)',
};

const fontColor: { [key in VariantType]: string } = {
  grey: 'var(--c-nd-600)',
  red: 'var(--c-red-300)',
};

const Root = styled.div<{ variant: VariantType }>`
  --border-size: 4px;
  color: ${({ variant }) => fontColor[variant]};
  background-color: ${({ variant }) => backgroundColors[variant]};
  border-left: var(--border-size) solid ${({ variant }) => borderColor[variant]};
  border-radius: var(--border-size);
  padding: var(--unit);
`;

type Props = {
  children?: React.ReactNode;
  variant?: VariantType;
};

export const Blockquote = ({ children, variant = 'grey' }: Props) => {
  return <Root variant={variant}>{children}</Root>;
};
